import { instance } from "libs/api";

import { ApiRoutesDrivers } from "./../../constants";
import { UpdateDaysOffBody } from "./updateDaysOff.types";

export const requestUpdateDaysOff = async (
  body: UpdateDaysOffBody,
  companyId?: string
): Promise<void> => {
  return await instance.patch(ApiRoutesDrivers.DaysOff, body, {
    params: companyId ? { companyId } : undefined
  });
};
